import React from 'react';

import { Box } from '@mui/joy';

import AttitudeIndicator from './AttitudeIndicator';
import BatteryStatus from './BatteryStatus';
import DroneTelemetry from './DroneTelemetry';
import FlightTimeEstimate from './FlightTimeEstimate';
import GimbalVisualization from './GimbalVisualization';

export interface FlightHUDWidgetProps {
  gimbalPitch: number;
  gimbalYaw: number;
  distanceToHome: number;
  horizontalSpeed: number;
  verticalSpeed: number;
  heading: number;
  windSpeed: number;
  windDirection: number;
  batteryPercent: number;
  estTimeToHome: string;
  estTimeUntilLowBattery: string;
  zoom: number;
  roll?: number; // degrees, positive right wing down
  pitch?: number; // degrees, positive nose up
}

const FlightHUDWidget: React.FC<FlightHUDWidgetProps> = (props) => {
  const {
    gimbalPitch,
    gimbalYaw,
    distanceToHome,
    horizontalSpeed,
    verticalSpeed,
    heading,
    windSpeed,
    windDirection,
    batteryPercent,
    estTimeToHome,
    estTimeUntilLowBattery,
    zoom,
    roll = 0,
    pitch = 0
  } = props;

  return (
    <Box className='flex space-x-4 p-2 bg-black bg-opacity-50 text-white rounded'>
      <GimbalVisualization
        yaw={gimbalYaw}
        pitch={gimbalPitch}
        roll={roll}
        heading={heading}
        fov={zoom > 0 ? 90 / zoom : 90}
        zoom={zoom}
        isLocked
      />
      <DroneTelemetry distanceToHome={distanceToHome} horizontalSpeed={horizontalSpeed} verticalSpeed={verticalSpeed} />
      <AttitudeIndicator
        roll={roll}
        pitch={pitch}
        heading={heading}
        windSpeed={windSpeed}
        windDirection={windDirection}
      />
      <BatteryStatus batteryPercent={batteryPercent} />
      <FlightTimeEstimate estTimeToHome={estTimeToHome} estTimeUntilLowBattery={estTimeUntilLowBattery} />
    </Box>
  );
};

export default FlightHUDWidget;
